import React from 'react'
import { HorizontalStack, Progress } from '@ztechapps/webui.util'
import { ProjectStatusBadge } from './ProjectStatus'
import type { ProjectStatusEnum } from '@ztechapps/common.contract'

export type ProjectStatusWithProgressProps = {
  status: ProjectStatusEnum
  progressNow: number
  progressMax: number
}
export const ProjectStatusWithProgress = ({ status, progressNow, progressMax }: ProjectStatusWithProgressProps) => {
  return (
    <HorizontalStack gap={1} className="align-items-center">
      <div>
        <ProjectStatusBadge status={status} />
      </div>

      <div className="w-100">
        <Progress now={progressNow} max={progressMax} />
      </div>
    </HorizontalStack>
  )
}
